import React from 'react';
import '../DevelopmentTools/DevelopmentTools.css';

function MobileAppPL({ onNavigate, isFirst, isLast }) {
  return (
    <div className="use-case-container">
      <div className="use-case-header">
        <h3 className="use-case-title">
          Aplikacja Mobilna / Logistyczne aplikacje mobilne
        </h3>
        <div className="navigation-buttons">
          <button
            onClick={() => onNavigate('prev')}
            disabled={isFirst}
            className="nav-button"
          >
            &lt;
          </button>
          <button
            onClick={() => onNavigate('next')}
            disabled={isLast}
            className="nav-button"
          >
            &gt;
          </button>
        </div>
      </div>

      {/* Przegląd */}
      <div id="mobileapp-overview" className="use-case-section">
        <h2 className="section-title">Przegląd</h2>
        <div className="overview-content">
          <p>
            Przeprojektowałam <strong>wiele aplikacji mobilnych dla logistyki</strong>, skupiając się na poprawie użyteczności, efektywności i dostępności. Upraszczając nawigację, <strong>optymalizując układy interfejsu</strong> oraz dostosowując projekty do wytycznych marki, usprawniłam procesy związane ze śledzeniem przesyłek, zarządzaniem magazynem i raportowaniem.
          </p>
          <p>Najważniejsze usprawnienia:</p>
          <ul className="overview-list">
            <li>Dolna nawigacja i boczne panele dla intuicyjnego dostępu.</li>
            <li><strong>Skalowalne wzorce UI</strong> wspierające różne role użytkowników.</li>
            <li>Ulepszone <strong>interakcje dotykowe</strong> i nawigacja gestami.</li>
            <li>Optymalizacja workflowów, by <strong>zmniejszyć obciążenie poznawcze</strong> i skrócić czas realizacji zadań.</li>
          </ul>
          <p>
            Dzięki badaniom, prototypowaniu i testom przekształciłam aplikacje logistyczne w szybsze, bardziej przyjazne narzędzia, zwiększając ich adopcję i efektywność.
          </p>
        </div>
      </div>

      {/* Specyfikacja */}
      <div id="mobileapp-specification" className="use-case-section">
        <h2 className="section-title">Specyfikacja</h2>
        <div className="specification-content">
          <h1 className="tool-name">Adaptacja nawigacji desktopowej do interfejsu mobilnego</h1>
          <div className="spec-details">
            <div className="spec-row">
              <div className="spec-label">Czas trwania:</div>
              <div>3 miesiące</div>
            </div>
            <div className="spec-row">
              <div className="spec-label">Wykorzystane narzędzia:</div>
              <div>Figma, Confluence</div>
            </div>
          </div>
          <div>
            <h3 className="highlight-blue" style={{ fontWeight: 'bold' }}>Cel</h3>
            <p className="goal-text">
              Celem było stworzenie domyślnej, przyjaznej dla urządzeń mobilnych nawigacji na bazie istniejącego interfejsu desktopowego w złożonej aplikacji logistycznej, zapewniając płynność i intuicyjność obsługi.
            </p>
          </div>
          <img
            src={require("../../../../assets/use-case-specification.png")}
            alt="Ilustracja specyfikacji use case"
            className="specification-image"
            style={{ 
              width: '100%', 
              maxWidth: '600px', 
              marginTop: '2rem',
              borderRadius: '4px',
              boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
            }}
          />
        </div>
      </div>

      {/* Wyzwanie */}
      <div id="mobileapp-problem" className="use-case-section">
        <h2 className="section-title">
          <span className="highlight-blue" style={{ fontWeight: 'bold' }}>Wyzwanie</span> – problem
        </h2>
        <div className="problem-content">
          <p>W projekcie napotkałam kilka kluczowych wyzwań związanych z interfejsem:</p>
          <ul className="overview-list">
            <li>
              <strong>Złożone interfejsy:</strong> Wiele istniejących rozwiązań miało przeładowane projekty, które przytłaczały użytkowników.
            </li>
            <li>
              <strong>Ograniczona przestrzeń ekranu:</strong> Małe ekrany wymagały efektywnego rozmieszczenia elementów wizualnych.
            </li>
            <li>
              <strong>Niewłaściwa nawigacja:</strong> Desktopowe menu z poziomą nawigacją i rozwijanymi listami nie sprawdzały się na urządzeniach mobilnych.
            </li>
            <li>
              <strong>Efektywność użytkownika:</strong> Pracownicy logistyki potrzebowali szybkiego, intuicyjnego dostępu do kluczowych funkcji, takich jak śledzenie przesyłek, zarządzanie magazynem i raporty.
            </li>
            <li>
              <strong>Spójność marki:</strong> Interfejs musiał być zgodny z systemem designu firmy, uwzględniając typografię, kolory i wzorce interakcji.
            </li>
          </ul>
          <h3 className="highlight-blue" style={{ fontWeight: 'bold', marginTop: '2rem' }}>Mój wpływ</h3>
          <p>W tym projekcie skupiłam się na:</p>
          <ul className="overview-list">
            <li><strong>Poprawie użyteczności</strong> dzięki podejściu mobile-first, które zwiększyło efektywność realizacji zadań.</li>
            <li><strong>Zmniejszeniu obciążenia poznawczego</strong> poprzez przejrzystą strukturę nawigacji.</li>
            <li><strong>Stworzeniu uniwersalnego rozwiązania</strong> możliwego do wdrożenia w wielu aplikacjach logistycznych.</li>
            <li>Łączeniu designu i developmentu poprzez <strong>ścisłą współpracę z inżynierami</strong>.</li>
            <li><strong>Zachowaniu spójności marki</strong> przez dostosowanie elementów UI do standardów firmy.</li>
            <li>Poprawie <strong>spójności wizualnej</strong> dla lepszej nawigacji i retencji użytkowników.</li>
            <li>Dopasowaniu wzorców do różnych ról, by zapewnić intuicyjne doświadczenie każdemu użytkownikowi.</li>
          </ul>
          <p>
            Dzięki tym strategiom wdrożyłam <strong>intuicyjny, efektywny i skalowalny system nawigacji mobilnej</strong>, zgodny z najlepszymi praktykami UX.
          </p>
        </div>
      </div>

      {/* Proces – podejście */}
      <div id="mobileapp-process" className="use-case-section">
        <h2 className="section-title">
          <span className="highlight-blue" style={{ fontWeight: 'bold' }}>Proces</span> – podejście
        </h2>
        <div className="process-content">
          <p>
            W tym projekcie skupiłam się na analizie istniejącego systemu oraz standardów mobilnych menu, by zapewnić intuicyjną i efektywną nawigację.
          </p>
          <h3 className="highlight-blue" style={{ fontWeight: 'bold', marginTop: '1.5rem' }}>Badania i analiza:</h3>
          <ul className="overview-list">
            <li>Przeanalizowałam firmowe <strong>wytyczne UI</strong>, by zapewnić <strong>zgodność i spójność</strong>.</li>
            <li>Analizowałam zachowania użytkowników poprzez wywiady z operatorami logistycznymi.</li>
            <li>Oceniałam popularne wzorce UX dla nawigacji mobilnej w aplikacjach biznesowych.</li>
          </ul>
          <h3 className="highlight-blue" style={{ fontWeight: 'bold', marginTop: '1.5rem' }}>Architektura informacji:</h3>
          <p>Przeprowadziłam ćwiczenia card sorting, by zoptymalizować hierarchię informacji i strukturę menu.</p>
          <img
            src={require("../../../../assets/card-sorting.png")}
            alt="Proces card sorting"
            className="card-sorting-image"
            style={{ 
              width: '100%', 
              maxWidth: '600px', 
              marginTop: '1rem',
              marginBottom: '1.5rem',
              borderRadius: '4px',
              boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
            }}
          />
          <h3 className="highlight-blue" style={{ fontWeight: 'bold', marginTop: '1.5rem' }}>Testy i iteracje:</h3>
          <ul className="overview-list">
            <li><strong>Zbierałam feedback od użytkowników</strong>, by dopracować strukturę menu, ikonografię i interakcje dotykowe.</li>
            <li><strong>Iterowałam</strong> nad czytelnością, odstępami i użytecznością, by spełnić <strong>standardy firmy</strong>.</li>
          </ul>
        </div>
      </div>

      {/* Rozwiązanie – ideacja */}
      <div id="mobileapp-solution" className="use-case-section">
        <h2 className="section-title">
          <span className="highlight-blue" style={{ fontWeight: 'bold' }}>Rozwiązanie</span> – ideacja
        </h2>
        <div className="solution-content">
          <img
            src={require("../../../../assets/solution-ideation.png")}
            alt="Ilustracja ideacji rozwiązania"
            className="solution-image"
            style={{ 
              width: '100%', 
              maxWidth: '600px', 
              marginBottom: '1.5rem',
              borderRadius: '4px',
              boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
            }}
          />
          <p>
            Przebudowa nawigacji pozwoliła operatorom logistycznym szybko uzyskiwać dostęp do kluczowych funkcji bez utraty użyteczności.
          </p>
          <h3 style={{ fontWeight: 'bold', marginTop: '1.5rem' }}>Dolny pasek nawigacji:</h3>
          <ul className="overview-list">
            <li>Zidentyfikowałam <strong>najczęściej używane funkcje</strong> (np. przesyłki, raporty) i umieściłam je w dolnym pasku nawigacji.</li>
            <li>Wykorzystałam <strong>czytelne, rozpoznawalne ikony</strong> z akcentami kolorystycznymi marki.</li>
          </ul>
          <h3 style={{ fontWeight: 'bold', marginTop: '1.5rem' }}>Boczne menu (side drawer) dla funkcji dodatkowych:</h3>
          <ul className="overview-list">
            <li>Przeniosłam <strong>ustawienia zaawansowane, zarządzanie profilem i powiadomienia</strong> do bocznego menu.</li>
            <li>Zaimplementowałam płynne <strong>gesty przesuwania</strong> dla szybkiego dostępu.</li>
          </ul>
          <h3 style={{ fontWeight: 'bold', marginTop: '1.5rem' }}>Pływający przycisk akcji (FAB):</h3>
          <ul className="overview-list">
            <li>Dodałam widoczny FAB do <strong>kluczowych zadań</strong>, np. <strong>skanowania kodu QR</strong>.</li>
          </ul>
          <h3 style={{ fontWeight: 'bold', marginTop: '1.5rem' }}>Spójna typografia i kolorystyka:</h3>
          <ul className="overview-list">
            <li>Stosowałam <strong>firmową typografię</strong> zgodnie z wytycznymi UI.</li>
            <li>Wykorzystałam <strong>główną i uzupełniającą paletę kolorów</strong> dla zachowania spójności marki.</li>
          </ul>
        </div>
      </div>

      {/* Cechy projektowe */}
      <div id="mobileapp-designfeatures" className="use-case-section">
        <h2 className="section-title">
          <span className="highlight-blue" style={{ fontWeight: 'bold' }}>Cechy projektowe</span> – wizualizacja
        </h2>
        <div className="design-features-content">
          <h3 className="highlight-blue" style={{ fontWeight: 'bold', marginTop: '1.5rem' }}>Wireframing i prototypowanie:</h3>
          <ul className="overview-list">
            <li><strong>Tworzyłam low-fidelity wireframes</strong>, by eksplorować różne struktury nawigacji mobilnej.</li>
            <li>Budowałam interaktywne <strong>prototypy w Figmie</strong>, by testować i optymalizować przepływy użytkownika.</li>
          </ul>
          <h3 style={{ fontWeight: 'bold', marginTop: '2rem' }}>Low-fidelity wireframes</h3>
          <img
            src={require("../../../../assets/lofi-wireframes.png")}
            alt="Low-fidelity wireframes"
            className="wireframes-image"
            style={{ 
              width: '100%', 
              maxWidth: '600px', 
              marginTop: '1rem',
              marginBottom: '2rem',
              borderRadius: '4px',
              boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
            }}
          />
          <h3 style={{ fontWeight: 'bold', marginTop: '1.5rem' }}>High-fidelity wireframes</h3>
          <img
            src={require("../../../../assets/hifi-wireframes.png")}
            alt="High-fidelity wireframes"
            className="wireframes-image"
            style={{ 
              width: '100%', 
              maxWidth: '600px', 
              marginTop: '1rem',
              marginBottom: '2rem',
              borderRadius: '4px',
              boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
            }}
          />
        </div>
      </div>

      {/* Podsumowanie */}
      <div id="mobileapp-conclusion" className="use-case-section" style={{ marginBottom: '40vh' }}>
        <h2 className="section-title">
          <span className="highlight-blue" style={{ fontWeight: 'bold' }}>Podsumowanie</span>
        </h2>
        <div className="conclusion-content">
          <p>
            Przeprojektowana nawigacja mobilna znacząco poprawiła użyteczność, skracając <strong>czas realizacji zadań o 30%</strong> w porównaniu do poprzedniej wersji. Wdrożenie <strong>menu hamburgera</strong> do obsługi wielu kategorii i linków pozwoliło skutecznie uporządkować dostęp do szerokiego zakresu treści w złożonej aplikacji logistycznej. Nowa struktura utrzymuje <strong>główną nawigację przejrzystą i skupioną na kluczowych zadaniach</strong>, zapewniając efektywność dla różnych grup użytkowników. Projekt ten podkreśla moją umiejętność <strong>przestrzegania wytycznych brandingowych</strong>, poprawy użyteczności i <strong>generowania realnej wartości biznesowej</strong> poprzez przemyślany design UI/UX.
          </p>
        </div>
      </div>
    </div>
  );
}

export default MobileAppPL; 